import { listen, isChangeAccountMessage, isData } from "@sinch/bus";
import { useEffect } from "react";
import { patchRefreshToken } from "../auth";

// Currently is made for Message media partner functionality
export const useChangeAccountHandler = () => {
  useEffect(() => {
    const unsub = listen((message) => {
      if (isData(message)) {
        patchRefreshToken({ accountId: message.payload.accountId });
      }
    }, isChangeAccountMessage);

    return unsub;
  }, []);
};
